"use client";
import {
  SearchProvider,
  SidebarCollapseProvider
} from "./chunk-WTO3J3EA.js";
import "./chunk-6C3VEZWH.js";

// src/provider.tsx
import { SidebarProvider } from "next-docs-zeta/sidebar";
import { ThemeProvider } from "next-themes";
import { jsx } from "react/jsx-runtime";
function RootProvider({
  children,
  enableThemeProvider = true,
  search
}) {
  const body = /* @__PURE__ */ jsx(SidebarProvider, { children: /* @__PURE__ */ jsx(SidebarCollapseProvider, { children: /* @__PURE__ */ jsx(SearchProvider, { ...search, children }) }) });
  return enableThemeProvider ? /* @__PURE__ */ jsx(
    ThemeProvider,
    {
      attribute: "class",
      defaultTheme: "system",
      enableSystem: true,
      disableTransitionOnChange: true,
      children: body
    }
  ) : body;
}
export {
  RootProvider
};
